import { ApiResponse, ApiRequest } from "@/api/types";

export const getReportMock = (
  params: ApiRequest.GetReport
): ApiResponse.Report => {
  return {
    graduate_year: 2020,
    company: {
      id: 1,
      name: "企業名",
      rating: 3.4
    },
    reports: Array(params.type === "MONTHLY" ? 12 : 4)
      .fill(0)
      .map((_, i) => ({
        id: 1,
        report_type: params.type,
        start_date: "2020-06-01",
        end_date: "2020-06-07",
        year: 2022,
        month: params.type === "MONTHLY" ? i + 1 : 12 /* 実際は1~12 */,
        week: params.type === "MONTHLY" ? 10 : i + 1,
        liked_report: {
          increments: Math.floor(Math.random() * Math.random() * 100),
          total: Math.floor((i + 1 * Math.random()) * 100),
          detail: {
            male_count: 10,
            female_count: 20,
            bachelor_count: 300,
            master_count: 300,
            humanities_course_count: 10,
            science_course_count: 10,
            increments_of_universities: Array(10)
              .fill(0)
              .map((_, i) => ({
                university: {
                  id: 1,
                  name: i + "大学"
                },
                count: i * 3 //NOTE: 適当な割り振り
              })),
            total_of_universities: Array(10)
              .fill(0)
              .map((_, i) => ({
                university: {
                  id: 1,
                  name: i + "大学"
                },
                count: i * 50 //NOTE: 適当な割り振り
              }))
          }
        }
      }))
  };
};
